import { Box, Header, Heading, InfiniteScroll, Image } from 'grommet';
import UploadView from './Upload/UploadView';

const InfiniteFeed = ({ user }) => {
    return (
        <Box gap='large' overflow='auto' margin='auto' fill>
            <InfiniteScroll items={user.files}>
                {(item) => (
                    <Box
                        gap="large"
                        alignSelf="center"
                        pad={{top: 'large', bottom: 'large'}}
                        border='between'
                        flex={false}
                    >
                        <Box height='large' width='large'>
                            <Image
                                fit='cover'
                                src={item}
                            />
                        </Box>
                    </Box>
                )}
            </InfiniteScroll>
        </Box>
    )
}

const NoFiles = ({ user }) => {
    return (
        <Box gap='medium' alignSelf='center' pad={{ top: 'large' }}>
            <Header alignSelf='center'>
                <Heading level={2}>You have no files uploaded to claim3</Heading>
            </Header>
            <UploadView user={user}/>
        </Box>
    )
}

const MyFiles = ({ user }) => {
    return (
        <Box height='100%' width='100%'>
            { user.files.length > 0 && (
                <Box height='100%' width='100%'>
                    <iframe src="https://claim3-myfiles.streamlit.app/?embed=true" title="claim3 dashboard" height='100%' width='100%' style={{ border: 'none' }} />
                </Box>
            )}
            { !user.files.length && <NoFiles user={user}/> }
        </Box>
    )
}

export default MyFiles;